import styled from 'styled-components';

export const ErrorMessageComponent = styled.div`
  margin-top: 2px;
  color: ${({ theme }) => theme.palette.danger[0]};
  white-space: pre-line;
`;

type ErrorMessageProps = {
  touched: Record<string, boolean>;
  errors: Record<string, string>;
  submitted: boolean;
  name: string;
  className?: string;
  dataTestId?: string;
};

export const ErrorMessage = ({ touched, errors, submitted, name, className, dataTestId }: ErrorMessageProps) => {
  if (!touched[name] && !submitted) {
    return <ErrorMessageComponent className={className} data-test-id={dataTestId} />;
  }

  return (
    <ErrorMessageComponent className={className} data-test-id={dataTestId}>
      {errors[name]}
    </ErrorMessageComponent>
  );
};

export default ErrorMessage;
